
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractInvoiceItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contractInvoiceItem'
  }

}
